<template>
    <v-container class="fill-height" style="display: block;" fluid>

        
        <!-- <span class="title">Upload your map coverge files(.shp,.shx,.dbf).</span> -->
    


        <v-form style="height: calc(100% - 10px);" ref="sectorForm" :lazy-validation="true" v-model="sectorFormValid">
        <vue-dropzone ref="myVueDropzone" id="file-dropzone" :class="{'drag-active': dragActive}" :options="dropzoneOptions" :useCustomSlot=true @vdropzone-file-added="handleNewFiles"
            @vdropzone-drag-enter="dragActive = true" @vdropzone-drag-over="dragActive = true" @vdropzone-drag-leave="dragActive = false" :include-styling="false">
            <div class="dropzone-custom-content">
                <!-- <h3 class="title">Drag and drop to upload files(.shp, .shx, .dbf)</h3>
                <div class="subtitle">or click to select a file from your computer</div> -->



                <!-- <v-data-table id="map-coverage-files-table" :headers="headers" :items="coverageFileObjs" :search="search" item-key="unique_key" sort-by="key" group-by="section" :items-per-page="-1" class="elevation-1" @dblclick:row="(e, item) => editItemClick(item.item)"></v-data-table> -->
                <v-data-table fixed-header id="map-coverage-files-table" :headers="headers" :items="coverageFileObjs" :search="search" item-key="name" sort-by="name" :items-per-page="-1" class="elevation-1" @click:row="(row, item, e) => rowClicked(row, item, e)" @dblclick:row="(e, item) => editItemClick(item.item)" hide-default-footer show-expand :expanded.sync="expandedRows">

                    <template v-slot:item.shp="{ item }">
                        <span v-if="!item.shp"></span>
                        <template v-else>
                            <v-progress-linear v-if="item.shp.uploading && item.shp.uploadProgress != 100" :value="item.shp.uploadProgress" color="#c42111" />
                            <span v-if="item.shp.uploading && item.shp.uploadProgress == 100">processing <v-icon>fas fa-spinner fa-spin</v-icon></span>
                            <span v-if="!item.shp.uploading">{{ getReadableFileSize(item.shp.size) }}</span>
                        </template>
                    </template>
                    <template v-slot:item.shx="{ item }">
                        <span v-if="!item.shx"></span>
                        <template v-else>
                            <v-progress-linear v-if="item.shx.uploading && item.shx.uploadProgress != 100" :value="item.shx.uploadProgress" color="#c42111" />
                            <span v-if="item.shx.uploading && item.shx.uploadProgress == 100">processing <v-icon>fas fa-spinner fa-spin</v-icon></span>
                            <span v-if="!item.shx.uploading">{{ getReadableFileSize(item.shx.size) }}</span>
                        </template>
                    </template>
                    <template v-slot:item.dbf="{ item }">
                        <span v-if="!item.dbf"></span>
                        <template v-else>
                            <v-progress-linear v-if="item.dbf.uploading && item.dbf.uploadProgress != 100" :value="item.dbf.uploadProgress" color="#c42111" />
                            <span v-if="item.dbf.uploading && item.dbf.uploadProgress == 100">processing <v-icon>fas fa-spinner fa-spin</v-icon></span>
                            <span v-if="!item.dbf.uploading">{{ getReadableFileSize(item.dbf.size) }}</span>
                        </template>
                    </template>


                    <template v-slot:item.status="{ item }">
                        <span v-if="item.status.required">{{ `REQUIRED [${item.status.required.join(',')}]` }}</span>
                        <span v-else-if="item.status.file">Downloading results <v-icon>fas fa-spinner fa-spin</v-icon></span>
                        <span v-else>{{ renderStatus(item) }}</span>
                    </template>



                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">

                            <v-simple-table dark @click.stop>
                                <template v-slot:default>
                                <thead>
                                    <tr @click.stop>
                                        <!-- <th width="45px"></th> -->
                                        <th class="text-left">LEGEND</th>
                                        <th class="text-left">Site</th>
                                        <th class="text-left">Sector</th>
                                        <th class="text-left">Prediction</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(feature, index) in item.status.features" :key="index" @click.stop>
                                        <td class="text-left">{{ feature.properties.LEGEND }}</td>
                                        <td class="text-left">
                                            <v-autocomplete placeholder="Select Site" class="site-select" outlined dense v-model="feature.properties.site_id" :items="$props.geoSiteList" item-value="site_id" item-text="site_name" color="#c42111" :filter="searchSites">
                                                <template v-slot:item="data">
                                                    <div class="my-1">
                                                        <span>{{ data.item.site_name }}</span><br>
                                                        <span>{{ data.item.site_office }}</span><br>
                                                        <span>{{ data.item.site_location }}</span>
                                                    </div>
                                                </template>
                                            </v-autocomplete>
                                        </td>
                                        <td class="text-left">
                                            <v-autocomplete placeholder="Select Sector" class="site-select" outlined dense v-model="feature.properties.sect_id" :items="getSectorsForSite(feature.properties.site_id)" item-value="sect_id" item-text="sect_mscid" color="#c42111" :rules="[uniqueSectors(feature.properties.sect_id, item.status.features)]" />
                                        </td>
                                        <td class="text-left">{{ feature.properties.Prediction }}</td>
                                        <th>{{ feature.status }}</th>
                                    </tr>
                                    

                                    <tr class="save-row" @click.stop>
                                        <td colspan="4">
                                            <span v-if="item.saving">Saving <v-icon>fas fa-spinner fa-spin</v-icon></span>
                                            <v-btn @click="saveSectorCoverageData(item)" color="#c42111" v-else>Save</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                            
                        </td>
                    </template>

                </v-data-table>

            </div>

        
            <span class="info-text">Drag and drop to upload map files(.shp, .shx, .dbf), or click to select.</span>
        </vue-dropzone>
        </v-form>
        


    </v-container>
</template>

<script>
import { fetchCoverageData } from "@/components/GeoMap/GeoMapCoverageAPI";
import vue2Dropzone from 'vue2-dropzone';
export default {
    name: 'MapCoverageFiles',
    props: ['geoSiteList'],
    components: {
        vueDropzone: vue2Dropzone
    },
    data: () => ({
        //acceptedFileTypes: ['.kml', '.kmz', 'cfg', '.dbf', '.shp', '.shx'],
        acceptedFileTypes: ['shp', 'shx', 'dbf'],
        // selectedFiles: null,
        // selectedFileObjs: [],


        coverageFilesDict: {},
        //coverageFileObjsList: [],
        coverageFileObjs: [],
        expandedRows: [],

        search: '',
        headers: [
            {text: 'Name', align: 'start', filterable: true, groupable: true, value: 'name'},
            {text: 'SHP File', filterable: false, groupable: false, value: 'shp'},
            {text: 'SHX File', filterable: false, groupable: false, value: 'shx'},
            {text: 'DBF File', filterable: false, groupable: false, value: 'dbf'},
            {text: 'Status', filterable: false, groupable: false, value: 'status'},
            //{text: 'GeoJSON', filterable: false, groupable: false, value: 'geojson'},
        ],



        dropzoneOptions: {
            url: '/',
            thumbnailWidth: 150,
            maxFilesize: 100000000, // 100MB
            parallelUploads: 6,
            autoQueue: false,
            createImageThumbnails: false,
            previewTemplate: '<div></div>',
            acceptedFiles: ".dbf,.shp,.shx"
        },
        dragActive: false,

        sectorFormValid: true,
        uniqueSectors: (sector, features) => {
            return (!sector || features.filter(f => f.properties.sector && f.properties.sector.sect_id == sector.sect_id).length < 2 || 'Dupliate');
        }

    }),

    computed: {

    },

    methods: {


        handleNewFiles(files) {
            // Note "files" isnt a list but is just 1 object. I turn it into a list because I want to make this code as compatible as possible with the possibility that in the future this function could accept a LIST of files.
            files = [files];
            this.dragActive = false;
            let route = `${TELSA.apiHost}geomap/coverage/files`;
            console.log('handleNewFiles: ', files);
            console.log('coverageFileObjs: ', this.coverageFileObjs);

            //return;
            for(let [idx, file] of files.entries()) {
                let fileName = TELSA.getFileName(file.name);
                let fileType = TELSA.getFileType(file.name).toLowerCase();

                if(!this.acceptedFileTypes.includes(fileType)) {
                    continue;
                }

                let coverageFileObj = this.coverageFileObjs.find(o => o.name == fileName);
                if(!coverageFileObj) {
                    coverageFileObj = {
                        name: fileName,
                        //expanded: false,
                        saving: false,
                        shp: false,
                        shx: false,
                        dbf: false,
                        status: ''
                    };
                    this.coverageFileObjs.push(coverageFileObj);
                }



                if(Object.hasOwn(coverageFileObj, fileType) && Object.keys(coverageFileObj[fileType]).length > 0) {
                    // They already added this specific file... Maybe its newer/better. should handle uploading this.
                }
                else {
                    coverageFileObj[fileType] = this.createBlankMapFileObject(file)
                }

                // prep for upload
                let formData = new FormData();
                formData.append('file', file);

                let fileUploadPromise = this.$http.post(route, formData,
                    {progress(e) {
                        let progress = Math.floor((e.loaded / e.total) * 100);
                        console.log('progress: ', progress);
                        coverageFileObj[fileType].uploadProgress = progress;
                    }}).then(response => {
                        let result = response.body;
                        console.log('UPLOAD RESULT: ', result);
                        

                        // We should send a message to the server to trigger the download. the server shouldn't do it automatically. 

                        coverageFileObj[fileType].uploading = false;
                        coverageFileObj.status = result;

                        if(result.file) {
                            this.getCoverageDataResults(coverageFileObj)
                        }
                });
            }
        },

        getCoverageDataResults(coverageFileObj) {
            let route = `${TELSA.apiHost}geomap/coverage/result`;
            return this.$http.post(route, {args: {file: coverageFileObj.status.file}}).then(response => {
                let result = response.body;
                console.log('getCoverageDataResults: ', result);
                coverageFileObj.status = result.data;
            });
        },

        getReadableFileSize(size) {
            return TELSA.readableFileSize(size);
        },

        createBlankMapFileObject(file) {
            return {
                uploading: true,
                uploadProgress: 0,
                file: file,
                name: file.name,
                type: file.type,
                size: file.size,
                status: ''
            };
        },
        renderStatus(coverageFileObj) {
            console.log('renderStatus: ', coverageFileObj);
            if(coverageFileObj.status.required) {
                return `REQUIRED [${coverageFileObj.status.required.join(',')}]`;
            }
            else if(coverageFileObj.status.features) {
                return `${coverageFileObj.status.features.length} Features`
            }

        },

        rowClicked(row, item, event) {
            event.stopPropagation();
            console.log('event: ', event);
            console.log('row: ', row);

            let idx = this.expandedRows.findIndex(r => r.name == row.name);
            if(idx > -1) {
                this.expandedRows.splice(idx, 1);
            }
            else {
                this.expandedRows.push(row);
            }
        },

        searchSites(item, queryText, itemText) {
            return (`${item.site_name}${item.site_office}${item.site_location}`.toLowerCase().includes(queryText));
        },

        getSectorsForSite(site_id) {
            let site = this.$props.geoSiteList.find(s => s.site_id == site_id);
            return site ? site.sectors || [] : [];
        },

        saveSectorCoverageData(coverageFileObj) {
            console.log('saveSectorCoverageData: ', coverageFileObj);

            // validation to make sure that all fields are filled out? do duplicate sectors?
            if(!this.$refs.sectorForm.validate()) {
                return;
            }

            coverageFileObj.saving = true;
            let route = `${TELSA.apiHost}geomap/coverage/save`;
            return this.$http.post(route, {args: {data: coverageFileObj.status}}).then(response => {
                let result = response.body;
                console.log('saveSectorCoverageData results: ', result);
                coverageFileObj.saving = false;
                if(result.saved_sectors) {
                    result.saved_sectors.forEach(sect_id => {
                        for(let feature of coverageFileObj.status.features) {
                            if(feature.properties && feature.properties.sector && feature.properties.sector.sect_id == sect_id) {
                                feature.status = 'saved';
                            }
                        }
                    });
                    fetchCoverageData(this);
                }
            });
        }
    },

    watch: {
    },

    mounted() {

    }


};
</script>

<style scoped>

    #map-coverage-files-table {
        /* height: calc(100% - 10px); */
    }

    #file-dropzone {
        margin: 1em auto;
        width: 100%;
        /* max-width: 1000px; */
        border: #000000 solid 1px;
        text-align: center;
        padding: 2em;
        cursor: pointer;
        background-color: rgba(48,48,48,0.75);

        min-height: 300px;
    }

    #file-dropzone.drag-active {
        border: #4caf50 solid 1px;
        background-color: rgba(48,48,48,0.5);
    }

    .file-error {
        animation: shake-horizontal 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
        color: #ff5252;
        margin-top: 0.5em;
        margin-left: 1em;
    }

    #file-dropzone .title {
        color: #ffffff;
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
    }
    #file-dropzone .subtitle {
        color: #ffffff;
    }


    .site-select {
        top: 7px;
        height: 55px;
    }

    .save-row:hover {
        background-color: transparent !important;
        cursor: default !important;
    }

    .info-text {
        /* bottom: 45px; */
        margin-top: 20px;
        display: block;
        position: relative;
        text-align: center;
    }

</style>
